<template>
  <tr>
    <td class="px-6 py-3 whitespace-no-wrap text-sm leading-4 font-medium text-gray-900">{{ sueldo.fecha | moment("DD MMMM YYYY") }}</td>
    <td class="px-6 py-3 whitespace-no-wrap text-sm leading-4 font-medium text-gray-900">{{ sueldo.sueldo_diario | currency }}</td>
    <td class="px-6 py-3 whitespace-no-wrap text-sm leading-4 font-medium text-gray-900">{{ sueldo.sueldo_semanal | currency }}</td>
    <td class="px-6 py-3 whitespace-no-wrap text-sm leading-4 font-medium text-gray-900">{{ sueldo.sueldo_semanal_real | currency }}</td>
  </tr>
</template>

<script>
export default {
  name: 'ItemSueldos',
  props: {
    sueldo: Object
  }
}
</script>
